export enum ProviderName {
  waze,
  sygic,
  tomtom,
  googlemaps
}
